// Imports of the module

import { formatNumber, parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type DelayedJobs = {
  id: number;
  priority: number;
  attempts: number;
  last_error?: string | null;
  owner_id?: number | null;
  owner_action?: string | null;
  owner_type?: string | null;
  failed_at?: string | null;
  locked_at?: string | null;
  locked_by?: string | null;
  queue?: string | null;
  run_at?: string | null;
  calculation_start_date?: string | null;
  created_at: string;
  updated_at?: string | null;
};

// Definition of the columns

export const delayed_jobs_columns: ColumnDef<DelayedJobs>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "priority",
    header: "Priority",
    cell: ({ row }) => (
      <div className="text-right">{formatNumber(row.getValue("priority"))}</div>
    ),
  },
  {
    accessorKey: "attempts",
    header: "Attempts",
    cell: ({ row }) => (
      <div className="text-right">{formatNumber(row.getValue("attempts"))}</div>
    ),
  },
  {
    accessorKey: "last_error",
    header: "Last Error",
    cell: ({ row }) => {
      const value = row.getValue("last_error");
      return value ? (
        <span title={value as string}>
          {(value as string).slice(0, 80)}
          {(value as string).length > 80 ? "…" : ""}
        </span>
      ) : null;
    },
  },
  {
    accessorKey: "owner_id",
    header: "Owner (ID)",
    cell: ({ row }) => {
      const value = row.getValue("owner_id");
      return value !== null && value !== undefined
        ? formatNumber(value as number)
        : "";
    },
  },
  {
    accessorKey: "owner_action",
    header: "Owner Action",
  },
  {
    accessorKey: "owner_type",
    header: "Owner Type",
  },
  {
    accessorKey: "failed_at",
    header: "Failed At",
    cell: ({ row }) =>
      row.getValue("failed_at")
        ? parseDate(row.getValue("failed_at") as string)
        : "",
  },
  {
    accessorKey: "locked_at",
    header: "Locked At",
    cell: ({ row }) =>
      row.getValue("locked_at")
        ? parseDate(row.getValue("locked_at") as string)
        : "",
  },
  {
    accessorKey: "locked_by",
    header: "Locked By",
  },
  {
    accessorKey: "queue",
    header: "Queue",
  },
  {
    accessorKey: "run_at",
    header: "Run At",
    cell: ({ row }) =>
      row.getValue("run_at") ? parseDate(row.getValue("run_at") as string) : "",
  },
  {
    accessorKey: "calculation_start_date",
    header: "Calculation Start Date",
    cell: ({ row }) =>
      row.getValue("calculation_start_date")
        ? parseDate(row.getValue("calculation_start_date") as string)
        : "",
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) =>
      row.getValue("created_at")
        ? parseDate(row.getValue("created_at") as string)
        : "",
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) =>
      row.getValue("updated_at")
        ? parseDate(row.getValue("updated_at") as string)
        : "",
  },
];
